// 渠道
import { useLazyQuery } from "@apollo/react-hooks"
// import { generateQuery } from "Methods/query"
import { tableInitialVariables } from "Methods/table"
import { Action, IVariable, TableName } from "Types/table"
import fragments from "../gql/fragment"
import gql from "graphql-tag"

export const generateQuery = (tableName: TableName, returnValue?: string) => {
    const fragmentName: TableName = tableName
    const fragment = fragments[fragmentName]
    const index = tableName === "users" ? "uid" : "id"
    return gql`
        query ${tableName}_list($limit: Int!, $offset: Int!, $order_by: [${tableName}_order_by!], $where: ${tableName}_bool_exp!) {
            ${tableName}(limit:$limit, offset:$offset, order_by: $order_by, where: { hidden: {_eq: false}}) {
                ...${tableName}
                ${returnValue === undefined ? "" : returnValue}
            }
            ${tableName}_aggregate(where: $where) {
                aggregate {
                    count(columns: ${index})
                }
            }
        }
        ${fragment}
    `
}
const query = generateQuery("article_type")

export function useFetchArticleType() {
    const [fetchData, { data }] = useLazyQuery(query, {
        variables: { ...tableInitialVariables, limit: 100 },
    })
    const { article_type = [] } = data || {}
    return {
        fetchArticleTypes: fetchData,
        articleTypes: article_type,
    }
}
